import { deleteGroupsBulkActionType, groupEntityName } from '../../../../../../backend/features/groups/shared';
import { allowCreateGroup } from '../../../../../../backend/features/permissions/shared';
import { useUserState } from '../../../../../../ui/hooks';
import { useContactManagementTranslation } from '../../../../../../ui/hooks/useContactManagementTranslation';
import { getFilterForBulkAction } from '../../../../../../utils';
import { DataTable, useDataTableUsingUrl } from '@juvare/common-data-table-ui/DataTable';
import { handleErrorDialog, showConfirmDialog } from '@juvare/common-web-ui/DialogHelper';
import { PageHeaderWithImage } from '@juvare/common-web-ui/PageHeader';
import { showInfoSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import { launchBulkAction } from '@juvare/platform-sdk-react/ui/features/bulk-actions';
import { useStorageClient } from '@juvare/platform-sdk-react/ui/hooks';
import AddIcon from '@mui/icons-material/Add';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { Box, FormControlLabel, Switch, Typography } from '@mui/material';
import React from 'react';
import { useGroupsTable } from '../../../hooks';
import { showGroupDetailsDialog } from './GroupDetailsDialog';
import { GroupSlideout } from './GroupSlideout';
export const GroupsList = ({ hideHeader, slideoutMenuItems }) => {
    const { t } = useContactManagementTranslation();
    const userState = useUserState();
    const [showAccountsImportGroups, setShowAccountsImportGroups] = React.useState(false);
    const { dataTableProps, appliedStorageFilters, setActiveRowId, clearActiveRow, reload } = useGroupsTable({
        useDataTableFunction: useDataTableUsingUrl,
        rowSelectionEnabled: true,
        onRowClick: () => undefined,
        showAccountsImportGroups,
    });
    const storageClient = useStorageClient(groupEntityName);
    const handleCreateGroup = () => {
        showGroupDetailsDialog({
            fullWidth: true,
            maxWidth: 'sm',
            title: t('panels.groups.newGroup'),
            showGroupTypeWidgets: true,
            initialData: {
                filterBased: false,
                visibility: 'private',
            },
            onSubmit: (data) => storageClient
                .post({
                data: Object.assign(Object.assign({}, data), { criteria: { filters: [] } }),
                action: 'create',
            })
                .then((response) => storageClient.get(response.id))
                .then((group) => {
                showInfoSnackbar({
                    message: t('panels.groups.groupCreated'),
                    autoHideDuration: 2000,
                });
                reload();
                setActiveRowId(group.id);
            })
                .catch(handleErrorDialog),
        });
    };
    const handleDeleteGroups = () => {
        showConfirmDialog({
            title: t('panels.groups.deleteGroups'),
            content: t('panels.groups.deleteGroupsConfirmation'),
            confirmLabel: t('common.delete'),
            onConfirm: () => {
                launchBulkAction({
                    type: deleteGroupsBulkActionType,
                    title: t('panels.groups.deletingGroups'),
                    params: {
                        filter: getFilterForBulkAction(dataTableProps === null || dataTableProps === void 0 ? void 0 : dataTableProps.selectedRowIds, appliedStorageFilters),
                    },
                    onClose: () => {
                        var _a;
                        (_a = dataTableProps.onDeselectAllRows) === null || _a === void 0 ? void 0 : _a.call(dataTableProps);
                        reload();
                    },
                });
            },
        });
    };
    return (React.createElement(React.Fragment, null,
        !hideHeader && React.createElement(PageHeaderWithImage, { gradient: 'cyan-dark', title: t('panels.groups.title') }),
        React.createElement(Box, { p: 4 },
            React.createElement(DataTable, Object.assign({}, dataTableProps, { customHeaderElement: React.createElement(FormControlLabel, { sx: { mr: 0 }, control: React.createElement(Switch, { checked: showAccountsImportGroups, onChange: () => setShowAccountsImportGroups((value) => !value), slotProps: {
                            input: {
                                'aria-label': t('panels.groups.showAccountsImportGroups'),
                            },
                        } }), label: React.createElement(Typography, { variant: 'body2' }, t('panels.groups.showAccountsImportGroups')), "data-test": 'show-accounts-import-groups-switch' }), mainAction: allowCreateGroup(userState)
                    ? {
                        icon: React.createElement(AddIcon, null),
                        label: t('panels.groups.addGroup'),
                        onClick: handleCreateGroup,
                    }
                    : undefined, localActions: [
                    {
                        icon: React.createElement(DeleteOutlineIcon, null),
                        label: t('panels.groups.deleteGroups'),
                        onClick: handleDeleteGroups,
                        'data-test': 'toolbar-delete-groups-button',
                    },
                ] }))),
        React.createElement(GroupSlideout, { slideoutMenuItems: slideoutMenuItems, groupId: dataTableProps.activeRowId, onClose: (changed) => {
                clearActiveRow();
                if (changed) {
                    reload();
                }
            } })));
};
